/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum IncidentSeverity {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  FATAL = 'FATAL'
}
